import { CheckIcon } from './Icons';

interface SelectionCheckboxProps {
  selected: boolean;
  onClick: () => void;
  className: string;
  checkedClassName?: string;
  uncheckedClassName?: string;
}

const SelectionCheckbox = ({
  selected,
  onClick,
  className,
  checkedClassName = 'bg-default border-default',
  uncheckedClassName = 'bg-white border-gray-300',
}: SelectionCheckboxProps) => (
  <button
    className={`${
      selected ? checkedClassName : uncheckedClassName
    } ${className}`}
    onClick={onClick}
  >
    <span>{selected && <CheckIcon />}</span>
  </button>
);

export default SelectionCheckbox;
